import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";
import { v4 as uuidv4 } from "uuid";

const getAdditionalAttributes = () => {
  const device = navigator.userAgent;
  const browser = window.navigator.appName;
  const os = navigator.platform;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const referrer = document.referrer;

  const sessionId = localStorage.getItem("session_id") || uuidv4();
  if (!localStorage.getItem("session_id")) {
    localStorage.setItem("session_id", sessionId);
  }

  const requesterIp = "";

  return {
    device,
    browser,
    os,
    screen_width: screenWidth,
    screen_height: screenHeight,
    referrer_url: referrer,
    session_id: sessionId,
    requester_ip: requesterIp,
  };
};

const captureEvent = (eventName, additionalProps = {}) => {
  const userId = localStorage.getItem("user_id") || null;
  const attributes = getAdditionalAttributes();

  const eventData = {
    user_id: userId,
    ...additionalProps,
    ...attributes,
  };
  posthog.capture(eventName, eventData);
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    captureEvent("page_view", { page_url: location.pathname });
  }, [location.pathname]);
};

export const useGlobalEventListeners = () => {
  useEffect(() => {
    const handleReferralClick = (e) => {
      const target = e.target.closest('[data-referal="true"]');

      if (target && target.getAttribute("data-referal") === "true") {
        captureEvent("referral_link_clicked", { referrer: target.href });
      }
    };

    const handleSignupFocus = (e) => {
      if (e.target.closest('[data-track="signup"]')) {
        captureEvent("signup_started", { field: e.target.name });
      }
    };

    const handleSignupSubmit = (e) => {
      if (e.target.closest('[data-track="signup-form"]')) {
        captureEvent("signup_completed", { form_id: e.target.id });
      }
    };

    document.addEventListener("click", handleReferralClick);
    document.addEventListener("focusin", handleSignupFocus);
    document.addEventListener("submit", handleSignupSubmit);

    return () => {
      document.removeEventListener("click", handleReferralClick);
      document.removeEventListener("focusin", handleSignupFocus);
      document.removeEventListener("submit", handleSignupSubmit);
    };
  }, []);
};

export const trackLoginSuccess = () => {
  captureEvent("login_success", {});
};

export const trackNewsletterSubscribed = () => {
  captureEvent("newsletter_subscribed", {});
};
